import { Outlet, useOutlet } from "react-router-dom";
import ScrollToTop from "../Components/ScrollToTop";
import Dashboard from "./Layout/Dashboard/Dashboard";
import Navbar from "./Layout/Navbar";

const MainIndex = () => {
   const hasChildren = useOutlet();

   return (
      <>
         <Navbar />
         <ScrollToTop />
         {hasChildren ? <Outlet /> : <Dashboard />}
      </>
   );
};

export default MainIndex;
